import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { LoaderComponent } from '../../../components/layout/loader/loader.component';
import { PeriodFormComponent } from '../../../components/periods/period-form/period-form.component';
import { TableGuruComponent } from '../../../components/table-guru/table-guru.component';

@Component({
  selector: 'app-periods-index',
  standalone: true,
  imports: [
    CommonModule,
    PeriodFormComponent,
    LoaderComponent,
    TableGuruComponent
  ],
  templateUrl: './periods-index.component.html',
  styleUrl: './periods-index.component.scss'
})
export class PeriodsIndexComponent {
  items: [] = [];
  private modalService = inject(NgbModal);
  reloadItems: boolean = false;

  editFormReference = PeriodFormComponent;

  constructor() { }

  openModal(item: any) {
    let self = this;
    const modalRef = this.modalService.open(PeriodFormComponent);
    modalRef.componentInstance.modalStyle = true;
    modalRef.componentInstance.item = item;
    modalRef.result.then((result) => {
      self.reloadItems = true;

      setTimeout(() => {
        self.reloadItems = false;
      }, 200);
    });
  }
}
